import Axios from 'axios';
import {REGISTRATION, APIBASE_URL} from '../config/cacheKey';
import {
    IGetFormRejectReasonsRequest,
    IGetFormRejectReasonsResponse,
    IRefrenceKeyRequest,
    IGetRegistrationFormsResponse,
    IInitializeRegistrationParamsResponse,
    IDropDownResponse,
    ICalculateLoanParamsResponse,
    ICalculateLoanParamsRequest,
    IGetRegistrationDurationRequest,
    IFinalizeByCustomerResponse,
    IGetPrimaryTermsResponse,
    IGeneratePrimaryTermsRequest,
    IGeneratePrimaryTermsResponse,
} from '../models/registration.model';
import {ApiResultModel} from '../models/common.model';

export const getRegistrationForms = (
    data: IRefrenceKeyRequest
): Promise<IGetRegistrationFormsResponse[]> => {
    return Axios.post<ApiResultModel<IGetRegistrationFormsResponse[]>>(
        APIBASE_URL + REGISTRATION + '/GetRegistrationForms',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const finalizeByCustomer = (
    data: IRefrenceKeyRequest
): Promise<IFinalizeByCustomerResponse> => {
    return Axios.post<ApiResultModel<IFinalizeByCustomerResponse>>(
        APIBASE_URL + REGISTRATION + '/FinalizeByCustomer',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const getFormRejectReasons = (
    data: IGetFormRejectReasonsRequest
): Promise<IGetFormRejectReasonsResponse[]> => {
    return Axios.post<ApiResultModel<IGetFormRejectReasonsResponse[]>>(
        APIBASE_URL + REGISTRATION + '/GetFormRejectReasons',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const initializeRegistrationParams = (data: {
    loanTemplateKey?: string;
}): Promise<IInitializeRegistrationParamsResponse> => {
    return Axios.post<ApiResultModel<IInitializeRegistrationParamsResponse>>(
        APIBASE_URL + REGISTRATION + '/InitializeRegistrationParams',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const getRegistrationDuration = (
    data: IGetRegistrationDurationRequest
): Promise<IDropDownResponse[]> => {
    return Axios.post<ApiResultModel<IDropDownResponse[]>>(
        APIBASE_URL + REGISTRATION + '/GetRegistrationDuration',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const calculateLoanParams = (
    data: ICalculateLoanParamsRequest
): Promise<ICalculateLoanParamsResponse> => {
    return Axios.post<ApiResultModel<ICalculateLoanParamsResponse>>(
        APIBASE_URL + REGISTRATION + '/CalculateLoanParams',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const GetPrimaryTerms = (
    data: IRefrenceKeyRequest
): Promise<IGetPrimaryTermsResponse> => {
    return Axios.post<ApiResultModel<IGetPrimaryTermsResponse>>(
        APIBASE_URL + REGISTRATION + '/GetPrimaryTerms',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const generatePrimaryTerms = (
    data: IGeneratePrimaryTermsRequest
): Promise<IGeneratePrimaryTermsResponse> => {
    return Axios.post<ApiResultModel<IGeneratePrimaryTermsResponse>>(
        APIBASE_URL + REGISTRATION + '/GeneratePrimaryTerms',
        data
    ).then((result) => {
        return result.data.data;
    });
};
